import { render, staticRenderFns } from "./SiteNetvisorInvoices.vue?vue&type=template&id=768c5264"
import script from "./SiteNetvisorInvoices.vue?vue&type=script&lang=js"
export * from "./SiteNetvisorInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports